/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { END } from 'redux-saga';
import {
    call, fork, put, select, take, takeEvery,
} from 'redux-saga/effects';
import mbpLogger from 'mbp-logger';
import { commonSelectors } from '../Member/ducks/Common';
import {
    loadOrderId, getOrderId, setLastOrdered, fetchLastOrderDetails,
} from './Order-Actions';
import { getOrderDetailsByOrderNumber, getOrdersByEmail } from '../../../apis/order-apis/fetchOrders';
import * as auth from '../Member/ducks/Auth/Plugin/auth/auth';

function* setOrderId(action) {
    try {
        yield put(loadOrderId(action.data));
    } catch (e) {
        console.log('ERROR');
    }
}

function* workerFetchLastOrderDetails({
    email,
}) {
    const isAuthenticated = yield select(commonSelectors.getIsAuthenticatedStatus);
    // Call Auth0 to get new accessToken
    const accessToken =  yield call(auth.getAccessTokenSafely);

    try {
        if (isAuthenticated && email) {
            const ordersByEmail = yield getOrdersByEmail(email, accessToken);

            if (ordersByEmail?.orders?.length) {
                const orderList = ordersByEmail.orders;
                const ORDERED_WITIN_TIME = 30 * 24 * 60 * 60 * 1000;
                let lastPlacedOrderWithinTime;

                // Get the regular products for now -- change this when functionality is completed for all product types
                const filteredRegularProductList = orderList.filter((order) => !order.items.some((item) => item.addonType !== ''));

                /**
                 * Get the last ordered item within the ORDERED_WITHIN_TIME
                 * sort the list in descending order
                 * get first index of list
                 * check if the order placed date is within the ORDERED_WITHIN_TIME
                 */
                filteredRegularProductList.sort((a, b) => new Date(b.orderPlaceddate) - new Date(a.orderPlaceddate));
                const lastOrdered = filteredRegularProductList[0];
                const isLastOrderedWithinTime = new Date(lastOrdered.orderPlaceddate).getTime() > (new Date().getTime() - ORDERED_WITIN_TIME);

                if (isLastOrderedWithinTime) {
                    lastPlacedOrderWithinTime = lastOrdered;
                }

                /**
                 * If ordered within ORDERED_WITIN_TIME, get order details
                 * set the orderDetails in redux to be used
                 */
                if (lastPlacedOrderWithinTime) {
                    const lastOrderedItemDetails = yield getOrderDetailsByOrderNumber(lastPlacedOrderWithinTime.orderNumber, accessToken);
                    if (lastOrderedItemDetails?.orderInfoList) {
                        yield put(setLastOrdered(lastOrderedItemDetails.orderInfoList));
                    }
                }
            } else {
                yield put(setLastOrdered(null));
            }
        } else {
            yield put(setLastOrdered(null));
        }
    } catch (ex) {
        mbpLogger.logError({
            function: 'workerFetchLastOrderDetails',
            appName: process.env.npm_package_name,
            module: 'Order-Operations.js',
            jsError: ex,
            email,
        });
    }
}

function* watchSetOrderId() {
    yield takeEvery(getOrderId().type, setOrderId);
}

function* watcherFetchLastOrderDetails() {
    let action = yield take(fetchLastOrderDetails().type);
    while (action !== END) {
        yield fork(workerFetchLastOrderDetails, action.payload);
        action = yield take(fetchLastOrderDetails().type);
    }
}

const watchers = [
    fork(watchSetOrderId),
    fork(watcherFetchLastOrderDetails),
];

export {
    watchers,
    setOrderId,

    // Actions
    loadOrderId,
    getOrderId,
};
